/**
 * Helper class used to generate a canvas to manipulate images
 */
var CanvasGenerator = /** @class */function () {
  function CanvasGenerator() {}
  /**
   * Create a new canvas (or offscreen canvas depending on the context)
   * @param width defines the expected width
   * @param height defines the expected height
   * @return a new canvas or offscreen canvas
   */
  CanvasGenerator.CreateCanvas = function (width, height) {
    if (typeof document === "undefined") {
      return new OffscreenCanvas(width, height);
    }
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  };
  return CanvasGenerator;
}();
export { CanvasGenerator };